import { render } from "./InputClienteTelefone.vue?vue&type=template&id=5e7aaf09"
import script from "./InputClienteTelefone.vue?vue&type=script&lang=js"
export * from "./InputClienteTelefone.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__